


















import {Component, Prop, Vue} from 'vue-property-decorator';
import User from "@/models/User";
import {Action} from "vuex-class";
import featureFlags from "@/util/featureFlags";
import LoadingButton from "@/components/LoadingButton.vue";
import UsageReport from "@/models/UsageReport";
import AdminAdapter from "@/adapters/admin";

@Component({
  components: {LoadingButton},
})
export default class UserListItem extends Vue {

  @Prop(Object) user!: User;
  @Action deleteUser!: (u: User) => Promise<void>;

  adminAdapter: AdminAdapter = new AdminAdapter();

  get isActive(): boolean {
    return this.user.active;
  }

  get roleName(): string {
    return this.user.role === "ADMIN" ? "Administrator" : "Normaler Benutzer";
  }

  get activeString(): string  {
    if (this.isActive) {
      return "Aktiv";
    } else {
      return "Eingeladen";
    }
  }

  copyLinkToClipboard() {
    this.adminAdapter.getInvitationToken(this.user).then((invitationToken: string) => {
      const invitationLink = featureFlags.frontendBaseUrl + "/redeem/" + encodeURIComponent(invitationToken);
      const copyText: HTMLInputElement = document.createElement("input");
      document.body.appendChild(copyText);
      copyText.value = invitationLink;
      copyText.select();
      document.execCommand("copy");
      document.body.removeChild(copyText);
      void this.$toast.success('Link wurde in die Zwischenablage kopiert.');
    }).catch(() => {
      void this.$toast.error('Kein Einladungs-Link für diesen Benutzer vorhanden.'); // TODO generate (for password reset)?
    });
  }

  async deleteThisUser() {
    const report: UsageReport = await this.adminAdapter.getUsageReportForUser(this.user);

    let message: string = "Wenn Du den Nutzer löscht, gibt es keine Möglicheit, ihn wieder herzustellen!";
    if (report.letterBoxCount > 0 || report.uploadCount > 0) {
      message = `Dieser Nutzer besitzt ${report.letterBoxCount} ${report.letterBoxCount > 1 ? 'Briefkästen' : 'Briefkasten'} ` +
       `und ${report.uploadCount} ${report.letterBoxCount > 1 ? 'Uploads' : 'Upload'}.
       Diese Daten gehen mit dem Nutzer verloren. Wirklich fortfahren?`;
    }

    const willDelete: boolean | null = await this.$swal({
      title: "Sind sie sicher?",
      text: message,
      icon: "warning",
      buttons: ["Nein, zurück", "Ja, Löschen"],
      dangerMode: true,
    });

    if (willDelete) {
      try {
        await this.deleteUser(this.user);
        this.$toast.success("Benutzer gelöscht");
      } catch (e) {
        this.$toast.error("Benutzer konnte nicht gelöscht werden");
      }
    }
  }
}
